import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Instagram, Facebook } from 'lucide-react';

// ═══════════════════════════════════════
// TIKTOK ICON
// ═══════════════════════════════════════
const TikTokIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-132">
    <path d="M19.59 6.69a4.83 4.83 0 
    01-3.77-4.25V2h-3.45v13.67a2.89 2.89 
    0 01-2.88 2.5 2.89 2.89 0 
    01-2.89-2.89 2.89 2.89 0 
    012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 
    6.33 0 00-.79-.05 6.34 6.34 0 
    00-6.34 6.34 6.34 6.34 0 
    006.34 6.34 6.34 6.34 0 
    006.33-6.34V8.69a8.18 8.18 0 
    004.78 1.52V6.74a4.85 4.85 0 
    01-1.01-.05z" data-id="element-133" />
  </svg>;

// ═══════════════════════════════════════
// ⬇️ CAMBIA ESTAS URLs POR TUS FOTOS
// Opción A: URL de internet
// Opción B: '/galeria/tu-foto.jpg'
// ═══════════════════════════════════════
const PREMIUM_1 = 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=1000&q=80';
// 💈 Barbero trabajando — Interior

const PREMIUM_2 = 'https://images.unsplash.com/photo-1621605815971-fbc98d665033?w=1000&q=80';
// ✂️ Corte de cabello moderno

const PREMIUM_3 = 'https://images.unsplash.com/photo-1622286342621-4bd786c2447c?w=1000&q=80';
// 🪒 Perfilado de barba con navaja

const PREMIUM_4 = 'https://images.unsplash.com/photo-1585747860715-2ba37e788b70?w=1000&q=80';
// 🏠 Interior barbería profesional

const PREMIUM_5 = 'https://images.unsplash.com/photo-1599351431202-1e0f0137899a?w=1000&q=80';
// 🛠️ Herramientas profesionales

const PREMIUM_6 = 'https://images.unsplash.com/photo-1605497788044-5a32c7078486?w=1000&q=80';
// 👑 Detalle silla de barbería

// ═══════════════════════════════════════
// COMPONENTE PRINCIPAL
// ═══════════════════════════════════════
export function Galeria() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  // ═════════════════════════════════════
  // ARRAY DE IMÁGENES
  // Modifica src y alt de cada foto aquí
  // ═════════════════════════════════════
  const images = [{
    src: PREMIUM_1,
    alt: 'Instalaciones premium El Rey Barba',
    categoria: 'Local'
  }, {
    src: PREMIUM_2,
    alt: 'Detalle de herramientas profesionales',
    categoria: 'Herramientas'
  }, {
    src: PREMIUM_3,
    alt: 'Perfilado de barba con navaja',
    categoria: 'Barba'
  }, {
    src: PREMIUM_4,
    alt: 'Corte de cabello profesional',
    categoria: 'Corte'
  }, {
    src: PREMIUM_5,
    alt: 'Degradado moderno y preciso',
    categoria: 'Degradado'
  }, {
    src: PREMIUM_6,
    alt: 'Ambiente exclusivo de barbería',
    categoria: 'Ambiente'
  }];
  return <section id="galeria" className="py-20 bg-gradient-to-b 
        from-black to-deepblack" data-id="element-134">
      <div className="max-w-7xl mx-auto 
        px-4 sm:px-6 lg:px-8" data-id="element-135">

        {/* ═══════════════════════════ */}
        {/* ENCABEZADO                  */}
        {/* ═══════════════════════════ */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-136">
          {/* Label */}
          <span className="text-gold text-sm 
            font-semibold uppercase tracking-widest" data-id="element-137">
            GALERÍA
          </span>

          {/* Título */}
          <h2 className="font-serif text-4xl 
            md:text-5xl font-bold text-bone 
            mb-4 mt-2" data-id="element-138">
            Nuestro Trabajo Habla{' '}
            <span className="text-gold" data-id="element-139">
              por Nosotros
            </span>
          </h2>

          {/* Subtítulo */}
          <p className="text-bone text-lg" data-id="element-140">
            Cada corte es una obra de arte
          </p>

          {/* Línea dorada */}
          <div className="w-24 h-0.5 
            bg-gold mx-auto mt-6" data-id="element-141" />
        </motion.div>

        {/* ═══════════════════════════ */}
        {/* GRID DE FOTOS              */}
        {/* ═══════════════════════════ */}
        <div className="grid grid-cols-1 
          md:grid-cols-2 lg:grid-cols-3 
          gap-6 mb-12" data-id="element-142">

          {images.map((image, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative overflow-hidden 
                rounded-lg aspect-[4/5] 
                cursor-pointer group bg-deepblack
                border border-gold/10 
                hover:border-gold/40
                transition-all duration-300" onMouseEnter={() => setHoveredIndex(index)} onMouseLeave={() => setHoveredIndex(null)} data-id="element-143">
              {/* IMAGEN */}
              <img src={image.src} alt={image.alt} loading="lazy" className={`w-full h-full 
                  object-cover object-center 
                  transition-transform duration-500 
                  ${hoveredIndex === index ? 'scale-110' : 'scale-100'}`} onError={e => {
            // Fallback automático
            (e.target as HTMLImageElement).src = 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=800&q=80';
          }} data-id="element-144" />

              {/* OVERLAY AL HACER HOVER */}
              <div className={`
                absolute inset-0 
                bg-gold/30 
                transition-opacity duration-300
                flex flex-col items-center 
                justify-center gap-3
                ${hoveredIndex === index ? 'opacity-100' : 'opacity-0'}`} data-id="element-145">
                {/* Texto */}
                <p className="text-white 
                  font-bold text-lg text-center 
                  px-4 drop-shadow-lg" data-id="element-146">
                  {image.alt}
                </p>

                {/* Badge categoría */}
                <span className="bg-black/70 
                  text-gold text-sm font-semibold 
                  px-4 py-1 rounded-full 
                  border border-gold/50" data-id="element-147">
                  {image.categoria}
                </span>
              </div>

            </motion.div>)}
        </div>

        {/* ═══════════════════════════ */}
        {/* SECCIÓN REDES SOCIALES     */}
        {/* ═══════════════════════════ */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-148">
          <p className="text-bone mb-6 text-lg" data-id="element-149">
            Síguenos y mira más trabajos diarios:
          </p>

          <div className="flex flex-wrap 
            justify-center gap-4" data-id="element-150">

            {/* INSTAGRAM */}
            <a href="https://instagram.com/barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 
                bg-gold/10 border border-gold 
                text-gold px-6 py-3 rounded-full 
                hover:bg-gold hover:text-deepblack 
                transition-all duration-300 
                font-semibold group" data-id="element-151">
              <Instagram className="w-5 h-5 
                group-hover:scale-110 
                transition-transform" data-id="element-152" />
              Instagram
            </a>

            {/* FACEBOOK */}
            <a href="https://facebook.com/Barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 
                bg-gold/10 border border-gold 
                text-gold px-6 py-3 rounded-full 
                hover:bg-gold hover:text-deepblack 
                transition-all duration-300 
                font-semibold group" data-id="element-153">
              <Facebook className="w-5 h-5 
                group-hover:scale-110 
                transition-transform" data-id="element-154" />
              Facebook
            </a>

            {/* TIKTOK */}
            <a href="https://www.tiktok.com/@pablosievorivas" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 
                bg-gold/10 border border-gold 
                text-gold px-6 py-3 rounded-full 
                hover:bg-gold hover:text-deepblack 
                transition-all duration-300 
                font-semibold group" data-id="element-155">
              <TikTokIcon data-id="element-156" />
              TikTok
            </a>

          </div>
        </motion.div>

      </div>
    </section>;
}